var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"title-container"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',{staticClass:"btn-container"},[_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }